import {
  Button,
  Drawer,
  Grid,
  List,
  ListItem,
  Menu,
  MenuItem,
  Paper,
  Typography,
} from "@mui/material";
import React, { SyntheticEvent, useEffect, useState } from "react";
import theme from "../../theme";
import useButtonStyles from "../../styles/useButtonStyles";
import { useAppSelector } from "../../redux/hooks";
import UpdateMemberForm from "../forms/UpdateMemberForm";
import { useParams } from "react-router-dom";
import UpdateMerchantDetailsNewUI from "./UpdateMerchantDetailsNewUI";
import { getFeaturePermissions } from "../../util/permissions";
import {
  filterConstants,
  permissionsConstants,
} from "../../constants/AppConstants";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import DefaultImage from  "../../assets/SuntecNewLogo.png";


const MerchantProfileNew = () => {
  const { getUserPermission: getMerchantPermissions } = usePermissionGetter(
    permissionsConstants.merchant,
    permissionsConstants.merchants
  );
  const buttonStyles = useButtonStyles();
  const [updateProfile, setUpdateProfile] = useState(false);
  const params = useParams();
  const { merchantId } = params;
  const merchantList = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList.merchantList
  );
  const userData = merchantList.find(
    (item: any) => item.leaseID === merchantId
  );
  const permissions = useAppSelector(
    (state: any) => state.persistReducers.login.permissions
  );

  const onImageLoadError = (event: SyntheticEvent<HTMLImageElement, Event>) => {
    event.currentTarget.src = DefaultImage;
  };

  return (
    <Grid sx={{ padding: "0 16px" }} width={"100%"} height={"90%"}>
      <Drawer
        anchor={"right"}
        open={updateProfile}
        onClose={() => {
          setUpdateProfile(false);
        }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px 0 0 16px",
          },
        }}
      >
        <Grid width={"920px"}>
          <UpdateMerchantDetailsNewUI
            type="Update"
            closeUpdate={setUpdateProfile}
            initialFormData={userData}
            merchantId={merchantId}
          />
        </Grid>
      </Drawer>
      <Grid
        height={"10%"}
        display={"flex"}
        justifyContent={"end"}
        sx={{
          padding: " 16px 0",
          borderBottom: theme.border?.smallGrey,
          margin: "0 24px",
        }}
      >
        {getMerchantPermissions("update") && (
          <Button
            sx={{ ...buttonStyles.textSecondary }}
            onClick={() => {
              setUpdateProfile(!updateProfile);
            }}
          >
            Update Profile
          </Button>
        )}
      </Grid>
      <Grid
        height={"22%"}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        sx={{ margin: "0 24px" }}
        borderBottom={theme.border?.smallGrey}
      >
        <Grid display={"flex"} justifyContent={"space-around"} gap={2} py={1}>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Merchant Name
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              {userData?.merchant_name ? userData?.merchant_name : "-"}
            </Typography>
          </Grid>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Unit Number
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              {userData?.unit_number ? userData?.unit_number : "-"}
            </Typography>
          </Grid>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Zone
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {userData?.zone ? userData?.zone : "-"}
            </Typography>
          </Grid>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              About Merchant
            </Typography>
            <Typography
              sx={{
                overflowX: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              {userData?.about_merchant ? userData?.about_merchant : "-"}
            </Typography>
          </Grid>
        </Grid>
        <Grid display={"flex"} justifyContent={"left"} gap={2} py={1}>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Merchant Logo
            </Typography>
            <img
              src={userData?.merchant_logo}
              onError={onImageLoadError}
              style={{
                width: "66px",
                height: "32px",
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        py={1}
        display={"flex"}
        flexDirection={"column"}
        gap={2}
        justifyContent={"center"}
        height={"15%"}
        sx={{ margin: "0 24px" }}
        borderBottom={theme.border?.smallGrey}
      >
        <Grid display={"flex"}>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Directory Category
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              {userData?.directoryCategory ? userData?.directoryCategory : "-"}
            </Typography>
          </Grid>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Directory Sub Category
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              {userData?.directorySubCategory
                ? userData?.directorySubCategory
                : "-"}
            </Typography>
          </Grid>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Halal Certified
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              {userData?.HalalCertified ? userData?.HalalCertified : "-"}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        display={"flex"}
        flexDirection={"column"}
        gap={2}
        justifyContent={"center"}
        height={"15%"}
        sx={{ margin: "0 24px" }}
        // py={1}
        borderBottom={theme.border?.smallGrey}
      >
        <Grid display={"flex"}>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              User Name
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              {userData?.username ? userData?.username : "-"}
            </Typography>
          </Grid>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Company Name
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              {userData?.companyName ? userData?.companyName : "-"}
            </Typography>
          </Grid>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Email
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              {userData?.email ? userData?.email : "-"}
            </Typography>
          </Grid>
          <Grid width={"25%"}>
            <Typography
              sx={{
                color: "#949494",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 400,
                fontSize: "14px",
              }}
            >
              Phone No
            </Typography>
            <Typography
              sx={{
                color: "#797B83",
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              {userData?.mobile_no ? userData?.mobile_no : "-"}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        display={"flex"}
        sx={{ margin: "0 24px" }}
        py={1}
        alignItems={"center"}
        height={"15%"}
        borderBottom={theme.border?.smallGrey}
      >
        <Grid width={"25%"}>
          <Typography
            sx={{
              color: "#949494",
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 400,
              fontSize: "14px",
            }}
          >
            Voucher Accepted
          </Typography>
          <Typography
            sx={{
              color: "#797B83",
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 600,
              fontSize: "14px",
            }}
          >
            {userData?.acceptsVoucher ? userData?.acceptsVoucher : "-"}
          </Typography>
        </Grid>
        <Grid width={"25%"}>
          <Typography
            sx={{
              color: "#949494",
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 400,
              fontSize: "14px",
            }}
          >
            Earn Points
          </Typography>
          <Typography
            sx={{
              color: "#797B83",
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 600,
              fontSize: "14px",
            }}
          >
            {userData?.payWithPoints ? userData?.payWithPoints : "-"}
          </Typography>
        </Grid>
        <Grid width={"25%"}>
          <Typography
            sx={{
              color: "#949494",
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 400,
              fontSize: "14px",
            }}
          >
            Hide From Directory
          </Typography>
          <Typography
            sx={{
              color: "#797B83",
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 600,
              fontSize: "14px",
            }}
          >
            {userData?.hideFromDirectory ? userData?.hideFromDirectory : "-"}
          </Typography>
        </Grid>
        <Grid width={"25%"}>
          <Typography
            sx={{
              color: "#949494",
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 400,
              fontSize: "14px",
            }}
          >
            Partner
          </Typography>
          <Typography
            sx={{
              color: "#797B83",
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 600,
              fontSize: "14px",
            }}
          >
            -
          </Typography>
        </Grid>
      </Grid>
      <Grid
        display={"flex"}
        sx={{ margin: "0 24px" }}
        alignItems={"center"}
        height={"10%"}
        py={1}
      >
        <Grid width={"50%"}>
          <Typography
            sx={{
              color: "#949494",
              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 400,
              fontSize: "14px",
            }}
          >
            Status
          </Typography>
          <Typography
            sx={{
              color:
                userData?.status.toLowerCase() === filterConstants.Active.toLowerCase()
                  ? theme?.color?.success
                  : theme?.color?.error,

              fontFamily: theme.font?.fontFamily.primary,
              fontWeight: 600,
              fontSize: "14px",
              textTransform: "capitalize",
            }}
          >
            {userData?.status ? userData?.status : "-"}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MerchantProfileNew;
